<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>
        <h4>Nytt företag</h4>
      </v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="pb-0 mb-0" v-if="error">
        <p class="mb-2 red--text">{{ error }}</p>
        <p class="mt-2">
          Vill du lägga till företaget utan att hämta adress från Bolagsverket så kan du välja 'Ange manuellt' knappen.
        </p>
      </v-card-text>

      <v-card-text>
        <v-text-field
          outlined
          v-mask="mask"
          placeholder="nnnnnn-nnnn"
          label="Organisationsnummer*"
          v-model="organizationalNumber"
          data-cy="organizational-number"
          :rules="[rules.required, rules.integer, rules.orgnr]"
        />
      </v-card-text>

      <v-card-actions class="d-flex justify-space-between">
        <v-btn color="secondary" @click="$emit('close')"><v-icon>$sl-cancel</v-icon>Avbryt</v-btn>

        <v-btn color="secondary" @click="$emit('manual')"><v-icon>$sl-edit</v-icon>Ange manuellt</v-btn>
        <v-btn @click="findCompany"><v-icon>$sl-download</v-icon>Hämta från Bolagsverket</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import {mask} from 'vue-the-mask'
import isObject from 'lodash/isObject'

// @group Company
// Styled CompanyNewModal component
export default {
  name: 'CompanyNewModal',

  mixins: [RulesMixin],
  directives: {
    mask
  },
  data: () => ({
    organizationalNumber: null,
    error: null,
    mask: '######-####'
  }),

  methods: {
    /**
     * @vuese
     * Used to get company information from  Bolagsverket
     * @arg The argument is an integer representing company organization number
     */
    findCompany() {
      this.error = null

      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      let orgNumber = this.organizationalNumber.split('-').join('')
      API.getBolagsverketCompany({data: {organizationalNumber: Number(orgNumber)}})
        .then(res => {
          //- Soft errors
          if (res.data.err) {
            this.error = res.data.msg
            return
          }
          if (isObject(res.data.email)) {
            res.data.email = null
          } else {
            res.data.email = res.data.email
          }
          // Fire company event ,after getting the result from  Bolagsverket
          // @arg The argument is object representing company data
          this.$emit('company', res.data)
        })
        .catch(error => {
          console.log(error)
          if (error && error.response && error.response.data) {
            this.error = error.response.data
            return
          }
        })
    }
  }
}
</script>

<style>
</style>
